import type { ReactNode } from 'react';

export const symbol_comic_bubble: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M754-206 646-415l105-105-91.21-91.21v-128.58H531.21L440-831l-91.21 91.21H220.21v128.58L129-520l91.21 91.21v128.58h128.58L440-209l104-104 210 107Zm90 90q-7 7-16 8.5t-19-3.5L556-240l-95 95q-9 9-21 9t-21-9l-95.06-95H190q-12.75 0-21.37-8.63Q160-257.25 160-270v-133.94L65-499q-9-9-9-21t9-21l95-95.06V-770q0-12.75 8.63-21.38Q177.25-800 190-800h133.94L419-895q9-9 21-9t21 9l95.06 95H690q12.75 0 21.38 8.62Q720-782.75 720-770v133.94L815-541q9 9 9 21t-9 21l-95 95 129 253q5 10 3.5 19t-8.5 16ZM441-518Z"
		/>
	</svg>
);
